import { ContractResource } from "@/interfaces";

/**
 * Whether the customer can register for arrival alerts, from the two
 * independent switches carried by the contract payload — and so whether the
 * alerts step belongs in the flow at all. When alerts are off, the step is
 * dropped rather than shown with a notice: nothing on it would be acted on.
 *
 * The company switch is the top level: when the company does not use alerts,
 * every contract under it is off regardless of its own flag. Only when the
 * company is on does the contract-level refusal decide.
 *
 * `alerts_status` is a real boolean but was added late, so an older API that
 * omits it is treated as "alerts are on" — hiding the step on a missing field
 * would silently remove a working feature.
 * `alert_refused` is still an int (0/1) on the backend and is coerced here.
 */
export const shouldShowAlertsStep = (
  contract?: ContractResource | null
): boolean => {
  const companyAlertsStatus =
    contract?.relationships?.company?.data?.attributes?.alerts_status;

  if (companyAlertsStatus === false) {
    return false;
  }

  return !Number(contract?.attributes?.alert_refused);
};
